import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient, getUseVisitLogKey, getUseVisitLogsKey } from '@/hooks'
import { APIErrorResponse, VisitLog, PatchVisitLog } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'

export type UsePatchVisitLogProps = {
  id: number
}

export const usePatchVisitLog = ({
  id,
}: UsePatchVisitLogProps): UseMutationResult<
  VisitLog,
  APIErrorResponse,
  PatchVisitLog
> => {
  const client = useApiClient()

  const queryClient = useQueryClient()

  const visitLogsListKey = getUseVisitLogsKey()
  const visitLogItemKey = getUseVisitLogKey(id)

  return useMutation(
    (params) =>
      client
        .patch(`plannings/visit_logs/${id}/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(visitLogsListKey)
        queryClient.invalidateQueries(visitLogItemKey)
      },
    }
  )
}
